// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 100,
  type: "trust_strip",
  name: "Promise strip",
  category: "Content",
  description: "Four short promises with a colored edge",
  defaultSettings: {
    item1Title: "Official warranty",
    item1Text: "Every device is sealed and registered",
    item2Title: "Cash on delivery",
    item2Text: "Check the box before you pay",
    item3Title: "Easy returns",
    item3Text: "7 day replacement for faulty units",
    item4Title: "Local support",
    item4Text: "Call or WhatsApp the store team",
  },
  fields: [
    { key: "item1Title", label: "First title", type: "text" },
    { key: "item1Text", label: "First detail", type: "text" },
    { key: "item2Title", label: "Second title", type: "text" },
    { key: "item2Text", label: "Second detail", type: "text" },
    { key: "item3Title", label: "Third title", type: "text" },
    { key: "item3Text", label: "Third detail", type: "text" },
    { key: "item4Title", label: "Fourth title", type: "text" },
    { key: "item4Text", label: "Fourth detail", type: "text" },
  ],
};

export default definition;
